import Blue from '../core'

new Blue({
  name: 'Sidebar Nav Mobile Accordion',
  selector: '.page-sidebar__mobile',
  setup(container) {
    const trigger = container.querySelector('.page-sidebar__mobile-toggle')
    const content = container.querySelector('.conference-nav, .header-side')
    const breakpoint = 768

    if (!!trigger && !!content) {
      let config = {
        container,
        trigger,
        content,
        breakpoint,
      }
      let t = new this.$toggle(config)

      // Set overflow to hidden on the body when a menu is open
      t.onToggle(() => {
        document.body.classList.toggle('fixed');
				if (content.matches('[data-active')) {
					content.style.visibility = 'visible';
					let maxHeight = window.innerHeight - content.getBoundingClientRect().top + "px";
					content.style.maxHeight = maxHeight;
				}	else {
					content.style.maxHeight = '';
					content.style.visibility = '';
				}
      })

      let windowWidth = window.innerWidth
      this.$addEvents(window, 'resize', () => {
        let newWindowWidth = window.innerWidth
        if (windowWidth !== newWindowWidth && newWindowWidth >= 769) t.close()
        windowWidth = newWindowWidth
      })
    }
  },
})
